/*
 * @Description: 路由配置
 * @Author: 山淑兰
 * @Date: 2019-09-10 10:05:16
 * @LastEditTime: 2020-07-15 15:33:50
 * @LastEditors: 山淑兰
 */
import Vue from 'vue'
import Router from 'vue-router'
import Home from './components/Home'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [{
            path: '/',
            name: 'home',
            meta: { auth: false },
            component: Home,
        },
        {
            path: '/meeting',
            name: 'meeting',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"meeting" */ './view/Meeting/index-new.vue'),
                children: [{
                    path: 'place',
                    name: 'place',
                    component: () =>
                        import(
                            /* webpackChunkName:"place" */
                            './view/Meeting/components/roomList-new.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'scheduleList',
                    name: 'scheduleList',
                    component: () =>
                        import(
                            /* webpackChunkName:"scheduleList" */
                            './view/Meeting/components/scheduleList-new.vue'
                        ),
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: 'details',
                    name: 'meeting-details',
                    component: () =>
                        import(
                            /* webpackChunkName:"meeting-details" */
                            './view/Meeting/components/details-new.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'searchList',
                    name: 'searchList',
                    component: () =>
                        import(
                            /* webpackChunkName:"meeting-searchList" */
                            './view/Meeting/components/searchList-new.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'selfSignin',
                    name: 'meeting-selfSignin',
                    component: () =>
                        import(
                            /* webpackChunkName:"selfSignin" */
                            './view/Meeting/components/selfSignin.vue'
                        ),
                },
                {
                    path: 'selfSigninSucceeded',
                    name: 'selfSigninSucceeded',
                    component: () =>
                        import(
                            /* webpackChunkName:"selfSigninSucceeded" */
                            './view/Meeting/components/selfSigninSucceeded.vue'
                        ),
                },
            ],
        },
        {
            path: '/mpro',
            name: 'mpro',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"meeting" */ './view/Meeting/index-news.vue'),
                children: [{
                    path: 'place',
                    name: 'place',
                    component: () =>
                        import(
                            /* webpackChunkName:"place" */
                            './view/Meeting/components/roomList-news.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'scheduleList',
                    name: 'scheduleList',
                    component: () =>
                        import(
                            /* webpackChunkName:"scheduleList" */
                            './view/Meeting/components/scheduleList-news.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'details',
                    name: 'meeting-details',
                    component: () =>
                        import(
                            /* webpackChunkName:"meeting-details" */
                            './view/Meeting/components/details-news.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'searchList',
                    name: 'searchList',
                    component: () =>
                        import(
                            /* webpackChunkName:"meeting-searchList" */
                            './view/Meeting/components/searchList-news.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'accsearchList',
                    name: 'accsearchList',
                    component: () =>
                        import(
                            /* webpackChunkName:"accsearchList" */
                            './view/Meeting/components/accsearchList.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'accordion',
                    name: 'scheduleAccordion',
                    component: () =>
                        import(
                            /* webpackChunkName:"scheduleAccordion" */
                            './view/Meeting/components/scheduleAccordion.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'selfSignin',
                    name: 'meeting-selfSignin',
                    component: () =>
                        import(
                            /* webpackChunkName:"selfSignin" */
                            './view/Meeting/components/selfSignin.vue'
                        ),
                },
                {
                    path: 'selfSigninSucceeded',
                    name: 'selfSigninSucceeded',
                    component: () =>
                        import(
                            /* webpackChunkName:"selfSigninSucceeded" */
                            './view/Meeting/components/selfSigninSucceeded.vue'
                        ),
                },
            ],
        },
        {
            path: '/guest',
            name: 'guest',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"meeting" */ './view/Guest/index.vue'),
                children: [{
                    path: 'place',
                    name: 'place',
                    component: () =>
                        import(
                            /* webpackChunkName:"place" */
                            './view/Guest/components/roomList.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'scheduleList',
                    name: 'scheduleList',
                    component: () =>
                        import(
                            /* webpackChunkName:"scheduleList" */
                            './view/Guest/components/scheduleList.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'detail',
                    name: 'guestdetail',
                    component: () =>
                        import(
                            /* webpackChunkName:"meeting-details" */
                            './view/Guest/components/detail.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
                {
                    path: 'searchList',
                    name: 'searchList',
                    component: () =>
                        import(
                            /* webpackChunkName:"meeting-details" */
                            './view/Guest/components/searchList.vue'
                        ),
                    meta: {
                        keepAlive: false,
                    },
                },
            ],
        },
		{
		    path: '/mproguest',
		    name: 'mproguest',
		    // meta: { auth: true, keepAlive: false },
		    component: () =>
		        import( /* webpackChunkName:"meeting" */ './view/Guest/index-new.vue'),
		        children: [{
		            path: 'place',
		            name: 'place',
		            component: () =>
		                import(
		                    /* webpackChunkName:"place" */
		                    './view/Guest/components/roomList-new.vue'
		                ),
		            meta: {
		                keepAlive: false,
		            },
		        },
		        {
		            path: 'scheduleList',
		            name: 'scheduleList',
		            component: () =>
		                import(
		                    /* webpackChunkName:"scheduleList" */
		                    './view/Guest/components/scheduleList.vue'
		                ),
		            meta: {
		                keepAlive: false,
		            },
		        },
		        {
		            path: 'detail',
		            name: 'guestdetail',
		            component: () =>
		                import(
		                    /* webpackChunkName:"meeting-details" */
		                    './view/Guest/components/detail.vue'
		                ),
		            meta: {
		                keepAlive: false,
		            },
		        },
		        {
		            path: 'searchList',
		            name: 'searchList',
		            component: () =>
		                import(
		                    /* webpackChunkName:"meeting-details" */
		                    './view/Guest/components/searchList.vue'
		                ),
		            meta: {
		                keepAlive: false,
		            },
		        },
		    ],
		},
        {
            path: '/signup',
            name: 'signup',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"signup" */ './view/SignUp/index.vue'),
                children: [{
                    path: 'meetingsignup',
                    name: 'meetingSignUp',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import(
                            /* webpackChunkName:"meetingSignUp" */
                            './view/SignUp/meetingsignup.vue'
                        ),
                },
                {
                    path: 'uploadProof',
                    name: 'uploadProof',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import(
                            /* webpackChunkName:"uploadProof" */
                            './view/SignUp/uploadProof.vue'
                        ),
                },
                {
                    path: 'invoice',
                    name: 'invoice',
                    component: () =>
                        import(
                            /* webpackChunkName:"invoice" */
                            './view/SignUp/invoice.vue'
                        ),
                },
                {
                    path: 'signupinfo',
                    name: 'signUpInfo',
                    component: () =>
                        import(
                            /* webpackChunkName:"signUpInfo" */
                            './view/SignUp/SignUpInfo.vue'
                        ),
                },
                {
                    path: 'modifyinfo',
                    name: 'modifyInfo',
                    component: () =>
                        import(
                            /* webpackChunkName:"modifyInfo" */
                            './view/SignUp/ModifyInfo.vue'
                        ),
                },
                {
                    path: 'electronicticket',
                    name: 'electronicticket',
                    component: () =>
                        import(
                            /* webpackChunkName:"electronicTicket" */
                            './view/SignUp/ElectronicTicket.vue'
                        ),
                },
                {
                    path: '/electronicsignin',
                    name: 'electronicsignin',
                    component: () =>
                        import(
                            /* webpackChunkName:"electronicsignin" */
                            './view/SignUp/ElectronicSignIn.vue'
                        ),
                },
                {
                    path: 'addPersonnel',
                    name: 'addPersonnel',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import(
                            /* webpackChunkName:"addPersonnel" */
                            './view/SignUp/addPersonnel.vue'
                        ),
                },
                {
                    path: 'my',
                    name: 'my',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import(
                            /* webpackChunkName:"addPersonnel" */
                            './view/SignUp/my.vue'
                        ),
                },
                {
                    path: 'modifyPhone',
                    name: 'modifyPhone',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import(
                            /* webpackChunkName:"addPersonnel" */
                            './view/SignUp/modifyPhone.vue'
                        ),
                },
                {
                    path: 'joinMeeting',
                    name: 'joinMeeting',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import(
                            /* webpackChunkName:"addPersonnel" */
                            './view/SignUp/joinMeeting.vue'
                        ),
                },
            ],
        },

        {
            path: '/transition',
            name: 'transition',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"transition" */ './view/Transition.vue'),
        },
        {
            path: '/login',
            name: 'login',
            meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"login" */ './view/Login.vue'),
        },
		{
		    path: '/elogin',  //嘉宾登录
		    name: 'elogin',
		    meta: { auth: true, keepAlive: false },
		    component: () =>
		        import( /* webpackChunkName:"login" */ './view/eLogin.vue'),
		},
		{
		    path: '/initPage',  //嘉宾登录之后页面
		    name: 'initPage',
		    meta: { auth: true, keepAlive: false },
		    component: () =>
		        import( /* webpackChunkName:"login" */ './view/export/initPage.vue'),
		},
        {
            path: '/liveInfo',
            name: 'liveInfo',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"meeting" */ './view/Live/LiveInfo.vue'),
        },
        {
            path: '/photoList',
            name: 'photoList',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"photoList" */ './view/Photo/PhotoList.vue'),
        },
        {
            path: '/photoDetail',
            name: 'photoDetail',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"photoDetail" */ './view/Photo/PhotoDetail.vue'),
        },
        {
            path: '/previewInfo',
            name: 'previewInfo',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import( /* webpackChunkName:"meeting" */ './view/Preview/PreviewInfo.vue'),
        },
        {
            path: '/pay',
            name: 'pay',
            component: () =>
                import( /* webpackChunkName:"pay" */ './view/SignUp/pay.vue'),
        },
        {
            path: '/upaycallback',
            name: 'upaycallback',
            component: () =>
                import(
                    /* webpackChunkName:"upaycallback" */
                    './view/SignUp/components/upaycallback.vue'
                ),
        },
        {
            path: '/hotel',
            name: 'hotel',
            // meta: { auth: true, keepAlive: false },
            component: () =>
              import( /* webpackChunkName:"signup" */ './view/Hotel/index.vue'),
              children: [{
                    path: '/hotelList',
                    name: 'hotelList',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelList.vue'),
                },
                {
                    path: '/hotelDetail',
                    name: 'hotelDetail',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelDetail.vue'),
                },
                {
                    path: '/hotelOrder',
                    name: 'hotelOrder',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelOrder.vue'),
                },
                {
                    path: '/hotelOrderList',
                    name: 'hotelOrderList',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelOrderList.vue'),
                },
                {
                    path: '/hotelOrderDetail',
                    name: 'hotelOrderDetail',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelOrderDetail.vue'),
                },
                {
                    path: '/hotelInvoice',
                    name: 'hotelInvoice',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelInvoice.vue'),
                },
                {
                    path: '/hotelInitPay',
                    name: 'hotelInitPay',
                    // meta: { auth: true, keepAlive: false },
                    component: () =>
                        import( /* webpackChunkName:"photoList" */ './view/Hotel/HotelInitPay.vue'),
                }
              ],
        },
        {
            path: '/scanCheckin',
            name: 'scanCheckin',
            // meta: { auth: true, keepAlive: false },
            component: () =>
                import(
                    /* webpackChunkName:"addPersonnel" */
                    './view/Checkin/ScanCheckin.vue'
                ),
        },
    ],
})

// wxid is the WeChat auth credential; only /transition may consume it (exchange for token),
// strip it from every other route to stop it propagating via shared links (prevents account takeover)
router.beforeEach((to, from, next) => {
    if (to.path === '/transition') return next()
    const q = to.query
    if (q && q.wxid !== undefined) {
        const clean = { ...q }
        delete clean.wxid
        next({ path: to.path, query: clean })
    } else {
        next()
    }
})

export default router